import { useState } from "react";
import { useParams } from "react-router";
import { useDropzone } from "react-dropzone";
import moment from "moment";
import XLSX from "xlsx-js-style";
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, Button,  Grid, Chip } from "@mui/material";
import { globalPostExportService,  } from "../../utils/globalApiServices";
import { downloadFileType } from "../../utils";
import { sampleExportApi } from "../reserve_rate/apiService";
import { PageLoader } from "../../shared_elements";
import { fieldDateFormat } from "../../constants";

const SUPPORTED_EXTENSIONS = [".xls", ".xlsx"];
const ImportModal = ({ sampleExportName, excelData, setExcelData, importDetails, isDisabled, onToggleModal,requiredHeaders, headerMap, transformExcelData, validateExcelData,onImportExcel ,samplePayload, handleItemClicked}) => {
  const [files, setFiles] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const params = useParams()
  const normalize = (h) =>h?.toString().trim().toLowerCase().replace(/\s+/g, " ")

  const normalizeRow = (row) => {
    const newRow = {};
    Object.keys(row).forEach((key) => {
      const normalizedKey = normalize(key);
      const mappedKey = headerMap[normalizedKey];
      if (mappedKey) { newRow[mappedKey] = row[key]; }
    });
    return newRow;
  };

  const onDrop = (acceptedFiles, rejectedFiles) => {
    setError(null);
    if (acceptedFiles.length === 0) return;
    const file = acceptedFiles[0];
    const ext = "." + file.name.split(".").pop().toLowerCase();
    if (!SUPPORTED_EXTENSIONS.includes(ext)) { setError(`File type ${ext} not supported.`); return; }
    setFiles([file]);
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary", cellStyles: false, });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      let parsedData = XLSX.utils.sheet_to_json(sheet, { defval: "" });
      if (!parsedData || parsedData.length === 0) {
        setError("Excel is empty or format is incorrect. Please use sample file for reference.");
        return;
      }
      const cleanedData = parsedData.map(normalizeRow);
      const firstRow = cleanedData[0] || {};
      const isValidHeader = requiredHeaders.every((h) => firstRow.hasOwnProperty(h));
      if (!isValidHeader) {
        setError("Invalid Excel format. Please use sample file format for reference.");
        return;
      }
      const validationError = validateExcelData(cleanedData);
      if (validationError) {
        setError(validationError);
        return;
      }
      const finalData = transformExcelData(cleanedData);
      setExcelData(finalData);
    };
    reader.readAsBinaryString(file);
    if (rejectedFiles.length) { setError("Some files were rejected. Please check type/size."); }
  };
  const removeFile = () => { setFiles([]); setExcelData([]); };
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, multiple: false, accept: { "application/vnd.ms-excel": [".xls"], "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"] }, });
  const handleDownloadSample = () => {
    setLoading(true)
    globalPostExportService(sampleExportApi(params?.leaseSlug), { download: "xlsx",...samplePayload })
      .then(response => {
        setLoading(false)
        if (response) { downloadFileType(response?.data, `${sampleExportName}_${moment().format(fieldDateFormat)}.`, "xlsx"); }
      });
  }
  return (
    <>
     <Dialog open={importDetails?.modal} maxWidth="sm" fullWidth>
      <DialogTitle className='dialog-header'>Import</DialogTitle>
      <DialogContent>
        <Grid sx={{ mt: 3 }}>
          <Box>
            <Box
              {...getRootProps()}
              sx={{ border: "2px dashed #ccc", borderRadius: "8px", p: 3, textAlign: "center", cursor: isDisabled ? "not-allowed" : "pointer", backgroundColor: isDragActive ? "#f0f0f0" : "#fafafa", }}
            >
              <input {...getInputProps()} />
              <Typography fontSize="13px"> Drag and drop, or click here to upload file </Typography>
            </Box>
            {error && (<Typography color="error" fontSize="12px" mt={1}> {error} </Typography>)}
            {files.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="body2">Preview:</Typography>
                <Chip label={files[0].name} onDelete={removeFile} variant="outlined" sx={{ mt: 1 }} />
              </Box>
            )}
            <Typography fontSize="11px" sx={{ background: "#ffff96", mt: 1, display: "inline-block" }} > Note: Supported (.xls, .xlsx), only 1 file allowed. Downloaded Sample (export file) can be used to import and create new records. </Typography>
          </Box>
        </Grid>
        <Button onClick={() => { handleDownloadSample(); handleItemClicked?.('Download Sample Button') }} sx={{ fontSize: "13px", textTransform: "none", p: 0, minWidth: "auto", color: "primary.main", textDecoration: "underline", "&:hover": { textDecoration: "underline", backgroundColor: "transparent", }, }} > Download Sample </Button>
        {isLoading ? <PageLoader /> :null}
      </DialogContent>
      <DialogActions sx={{ mr: 2 }}>
        <Button variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked?.('Cancel Button') }}> Cancel </Button>
        <Button variant="contained" size="small" disabled={error!== null ||  !excelData.length} onClick={() => {onImportExcel();onToggleModal(); handleItemClicked?.('Save Button') }} > Save </Button>
      </DialogActions>
    </Dialog>
    </>
   
  );
};

export default ImportModal;